<template>
    <div class="font-main-regular">
        <router-view />
    </div>
</template>
<script>
import { mapState } from 'vuex';
import ConfigManager from "@/config/ConfigManager.js";
//store
import SideMenuStore from "@/store/SideMenuStore.js";
import AccountStore from "@/store/AccountStore.js";

export default {
    created: function () {
        console.log("run local environment", ConfigManager.getApi());
        AccountStore.methods.init();
    },
    computed: {
        ...mapState({
            animation: state => state.transition.animation,
        }),
    },
    provide: {
        SideMenuStore: SideMenuStore,
        AccountStore: AccountStore,
    },
}
</script>
<style lang="scss">
@import "./style/base/base.scss";
@import "./style/main.scss";
@import "./style/PageTransition.scss";
</style>
